
import React from 'react';
import { useParams, useNavigate } from "react-router-dom";
import SupplierFormNew from '@/components/suppliers/SupplierFormNew';
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

const EditSupplierPage = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  if (!id) {
    return (
      <div className="text-center py-10">
        <p className="text-destructive">Supplier ID is missing. Please return to the suppliers list.</p>
        <Button className="mt-4" onClick={() => navigate('/cost-center/suppliers')}>
          Back to Suppliers
        </Button>
      </div>
    );
  }

  return (
    <div>
      <div className="mb-6 flex items-center gap-4">
        <Button variant="ghost" size="icon" onClick={() => navigate('/cost-center/suppliers')}>
          <ArrowLeft className="h-5 w-5" />
        </Button>
        <div>
          <h1 className="text-2xl font-bold">Edit Supplier</h1>
          <p className="text-muted-foreground">
            Update supplier information
          </p>
        </div>
      </div>

      <SupplierFormNew supplierId={id} />
    </div>
  );
};

export default EditSupplierPage;
